import OldInput from "../../form_components/OldInput";
import * as Papa from "papaparse";
import { createUuid } from "@app/utilities";
import BaseDialog from "./BaseDialog";

export default class CustomCSVDialog extends BaseDialog {
  /**
   * Dialog for CSV upload and preview
   * @module CustomCSVDialog
   * @param {Object} props React render
   */
  constructor(props) {
    super(props);
    this.addHandle = this.handleAdd.bind(this);
    this.deleteHandle = this.handleDelete.bind(this);
    this.name = "";
    this.isValidCSV = true;
    if (
      typeof this.props.context.getConfig === "function" &&
      this.props.context.getConfig("name")
    ) {
      this.name = this.props.context.getConfig("name");
    }
    this.value = "";
    this.error = 0;
  }

  /**
   * Add to application
   * @param event
   */
  handleAdd(event) {
    const ts = window.apm.timestamp;
    if (!this.value) {
      return;
    }
    if (this.props.reupload) {
      if (this.error > 0) {
        window.apm.notification.post("error");
      } else {
        this.props.context.props.data.value = this.value;
        this.props.context.update(null, {
          id: this.props.context.props.data.id,
          name: this.name,
          value: this.value,
          lastLocalChange: ts,
          createdTime: this.createdTime
        });
        w2popup.close();
      }
    }
    if (this.props.new) {
      this.props.context.add({
        id: createUuid(),
        name: this.name,
        value: this.value,
        createdTime: ts
      });
    }
    w2popup.close();
  }

  /**
   * Delete from application
   * @param event
   */
  handleDelete(event) {
    const id = this.props.context.props.data.id;
    // The following method modifies the value of this.props.context.props.data.id 
    this.props.context.remove();
    w2popup.close();
    window.apm.updateDeletedCsvDataMap(id);
  }

  /**
   * Set config proxy
   * @param {string} key
   * @param {string} value
   */
  setConfig(key, value) {
    this.name = value;
  }

  /**
   * Get config proxy
   * @param {string} key
   * @returns {string}
   */
  getConfig(key) {
    return this.name;
  }

  componentDidMount() {
    super.componentDidMount();
    document.addEventListener("ev-dialog-add", this.addHandle);
    document.addEventListener("ev-dialog-delete", this.deleteHandle);
    this.value = "";
  }

  unregister() {
    document.removeEventListener("ev-dialog-add", this.addHandle);
    document.removeEventListener("ev-dialog-delete", this.deleteHandle);
  }

  /**
   * React render
   * @returns {XML}
   */
  render() {
    // Get CSV preview

    if (this.props.context.props.data && this.value === "") {
      var value = this.props.context.props.data.value;
    } else {
      var value = this.value;
    }
    if (
      !this.props.new &&
      typeof this.props.context.getConfig === "function" &&
      this.props.context.getConfig("script")
    ) {
      value = this.props.context.getConfig("script");
    }

    if (this.props.reupload && this.value !== "") {
      const existingHeaders = Papa.parse(this.props.context.props.data.value, {
        header: true
      });
      const newHeaders = Papa.parse(this.value, {
        header: true
      });
      if (
        JSON.stringify(existingHeaders.meta.fields) !==
        JSON.stringify(newHeaders.meta.fields)
      ) {
        this.error++;
        window.apm.notification.post(
          "error",
          window.l.notification.headers_doesnt_match
        );

        value = this.props.context.props.data.value;
      }
    }
    const csv = Papa.parse(value, {
      header: true,	
      skipEmptyLines: true,
    });
    const header = csv.meta.fields;
    var headerRow = [];
    var rows = [];

    if(csv.errors.length > 0 && this.name!=="") {
      this.isValidCSV = false;
    }else {
      this.isValidCSV = true;
      for (var i = 0; i < header.length; i++) {
        headerRow.push(<th key={i}>{header[i]}</th>);
      }
  
      const len = Math.min(200, csv.data.length);
      for (var i = 0; i < len; i++) {
        if (Object.keys(csv.data[i]).length <= 1) {
          continue;
        }
        var r = [];
        for (var j = 0; j < header.length; j++) {
          r.push(<td key={i + "-" + j}>{csv.data[i][header[j]]}</td>);
        }
        rows.push(<tr key={i}>{r}</tr>);
      }
      var footer = null;
      if (rows.length === 200 && csv.data.length > 200) {
        footer = (
          <td style={{ color: "var(--theme-text-emphasis)" }} colSpan={2}>
            <span>
              <b>
                &#8943;{" "}
                {window.l.form.and_space +
                  (csv.data.length - rows.length) +
                  window.l.form.space_more_rows}
              </b>
            </span>
          </td>
        );
      }
    }

    return (
      <div className="container-fluid">
        <div
          className="script-header"
          style={{ fontWeight: "normal", display: "block" }}
        >
          <div style={{ width: "100%" }}>
            <OldInput
              label={window.l.popup.csv_name}
              context={this}
              valKey={"csvName"}
              value={this.name || "Untitled_CSV.csv"}
              valRules={{ noEmpty: true }}
              readonly
            />
          </div>
        </div>
        <div className="script-wrapper">
          {!this.props.new && (
            <div>
              <input
                type="file"
                name="fileField"
                accept=".csv"
                style={{ margin: "10px 0" }}
                onChange={event => {
                  const file = event.currentTarget.files[0];
                  if (!file) {
                    return;
                  }
                  this.name = file.name;
                  const reader = new FileReader();
                  reader.onload = e => {
                    this.value = e.target.result;
                    this.forceUpdate();
                  };
                  reader.readAsText(file);
                }}
              />
              <div style={{ width: "100%", overflow: "auto" }}>
                <table
                  style={{ marginBottom: 0 }}
                  className={
                    "summary-table table table-condensed table-responsive"
                  }
                >
                  <thead>
                    <tr>{headerRow}</tr>
                  </thead>
                  <tbody>{rows}</tbody>
                  <tfoot>
                    <tr>{footer}</tr>
                  </tfoot>
                </table>
              </div>
            </div>
          )}
          {this.props.new && (
            <div>
              <input
                type="file"
                name="fileField"
                accept=".csv"
                style={{ margin: "10px 0" }}
                onChange={event => {
                  const file = event.currentTarget.files[0];
                  if (!file) {
                    return;
                  }
                  this.name = file.name;
                  const reader = new FileReader();
                  reader.onload = e => {
                    this.value = e.target.result;
                    this.forceUpdate();
                  };
                  reader.readAsText(file);
                }}
              />
              {this.isValidCSV && (
                <div style={{ width: "100%", overflow: "auto" }}>
                <table
                  style={{ marginBottom: 0 }}
                  className={
                    "summary-table table table-condensed table-responsive"
                  }
                  >
                  <thead>
                    <tr>{headerRow}</tr>
                  </thead>
                  <tbody>{rows}</tbody>
                  <tfoot>
                    <tr>{footer}</tr>
                  </tfoot>
                </table>
              </div>
              )}
              {!this.isValidCSV && (
                <div style={{ width: "100%", overflow: "auto" }}>
                  <div className="alert alert-warning" role="alert">
										<p> 
											<i className={"fe icon-alert-triangle"} />  {window.l.notification.csv_invalid}
										</p>
									</div>
                  <div className="alert alert-warning" role="alert">
                    {csv.errors.map((error, index) => {
                      return (
                        <div key={index}>
                          <p>
                            <b>{window.l.popup.error} {" "} {index + 1}:</b> {error.message}
                          </p>
                          <p>
                            <b>{window.l.notification.row}:</b> {error.row}
                          </p>
                        </div>
                      );
                    })}
                  </div>

                </div>
              )}
            </div>
          )}
        </div>
        <div className="script-footer" />
      </div>
    );
  }
}
